import { HANDLE_CLICK } from '../actions/_types';

const to = '/events/search';

export default () =>
  () =>
  ({ [HANDLE_CLICK]: handleClick, courseName }) => ({
    text: 'There are no sessions available in the area you searched. Try looking up a different location or ',
    link: {
      label: 'search for another program',
      attr: {
        href: to,
      },
      on: {
        click: (event) =>
          handleClick({
            event,
            to,
            external: true,
            analytics: {
              section: courseName,
              linkText: 'no-session__search',
            },
          }),
      },
    },
  });
